import Swiper from 'swiper';

window.initSwiper = () => {
  const swipers = document.querySelectorAll('.swiper');
  if (!swipers || swipers.length === 0) return;

  swipers.forEach(swiper => {
    let swiperContainer = swiper.querySelector('.swiper .swiper-container') || swiper.querySelector('.swiper-container');
    if (!swiperContainer) {
      console.warn('No swiper container for', swiper);
      return;
    }

    const paginationEl = swiper.querySelector('.swiper-pagination') || null;
    const options = {
      speed: 400,
      spaceBetween: 10,
      lazy: true,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
      } : undefined,
    };

    if (swiper.classList.contains('swiper-products')) {
      const thumbsContainer = swiper.querySelector('.swiper-thumbs.swiper-container') || document.querySelector('.swiper-thumbs.swiper-container');
      if (thumbsContainer) {
        const thumbs = new Swiper(thumbsContainer, {
          preloadImages: false,
          lazy: true,
          spaceBetween: 20,
          slidesPerView: 4,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          direction: 'horizontal',
          slideToClickedSlide: true,
          threshold: 25
        });
        options.thumbs = { swiper: thumbs };
        options.zoom = { maxRatio: 2.5 };
        swiperContainer = swiper.querySelector('.swiper-main.swiper-container') || swiperContainer;
      }
    }

    // sf navigation
    if (swiper.classList.contains('sf-swiper-arrows')) {
      const nextEl = swiper.querySelector('.sf-swiper-control-next');
      const prevEl = swiper.querySelector('.sf-swiper-control-prev');
      if (nextEl && prevEl) options.navigation = { nextEl, prevEl };
    }

    // navigation
    if (swiper.classList.contains('swiper-arrows')) {
      const nextEl = swiper.querySelector('.swiper-control-next');
      const prevEl = swiper.querySelector('.swiper-control-prev');
      if (nextEl && prevEl) options.navigation = { nextEl, prevEl };
    }

    // social gallery
    if (swiper.classList.contains('swiper-social-gallery')) {
      options.slidesPerView = 2;
      options.spaceBetween = 20;
      const nextEl = swiper.querySelector('.swiper-control-next');
      const prevEl = swiper.querySelector('.swiper-control-prev');
      if (nextEl && prevEl) options.navigation = { nextEl, prevEl };
      options.breakpoints = {
        576: { slidesPerView: 3 },
        992: { slidesPerView: 4, spaceBetween: 30 },
        1200: { slidesPerView: 5 },
      };
    }

    if (swiper.classList.contains('sf_new_slider')) {
      options.slidesPerView = 1;
      options.spaceBetween = 24;
      options.breakpoints = {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      };
    }

    if (swiper.classList.contains('sf_usp_slider')) {
      options.pagination = false;
      options.navigation = false;
      options.autoplay = {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true 
      };
    }

    if (swiper.classList.contains('sf_homepage_slider_wrapper')) {
      options.autoplay = {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true 
      };
      options.loop = true;
    }

    // Init swiper
    const slideshow = new Swiper(swiperContainer, options);

    // Force pagination render/update after init (helpful when initialized early or images still loading)
    if (slideshow.pagination && typeof slideshow.pagination.render === 'function') {
      slideshow.pagination.render();
      slideshow.pagination.update();
    }
    // Force a full update too (layout)
    slideshow.update();

    // Ensure pagination updates when slides change (defensive)
    slideshow.on('slideChange', () => {
      if (slideshow.pagination) {
        slideshow.pagination.render && slideshow.pagination.render();
        slideshow.pagination.update && slideshow.pagination.update();
      }
    });

    // Also update at the end of transition (more reliable in some envs)
    slideshow.on('slideChangeTransitionEnd', () => {
      if (slideshow.pagination) {
        slideshow.pagination.update && slideshow.pagination.update();
      }
    });

    // For mouse swipes sometimes touchEnd fires later — keep a defensive touch listener
    slideshow.on('touchEnd', () => {
      if (slideshow.pagination) slideshow.pagination.update && slideshow.pagination.update();
    });

    // If images/lazy loading can change sizes, wait for images to load and then update
    const imgs = swiper.querySelectorAll('img');
    if (imgs && imgs.length) {
      let cnt = 0;
      const tryUpdate = () => {
        cnt++;
        if (cnt >= imgs.length) {
          // do one final repaint/update after images loaded
          setTimeout(() => {
            slideshow.update();
            slideshow.pagination && slideshow.pagination.update && slideshow.pagination.update();
          }, 30);
        }
      };
      imgs.forEach(img => {
        if (img.complete && img.naturalWidth > 0) {
          tryUpdate();
        } else {
          img.addEventListener('load', tryUpdate);
          img.addEventListener('error', tryUpdate);
        }
      });
    }

    // product-specific workaround (your existing code)
    if (swiper.classList.contains('swiper-products')) {
      setTimeout(() => slideshow.update(), 1000);
      if (slideshow.zoom) slideshow.zoom.disable();
      slideshow.update();
    }

  });

 

};

// Run on DOMContentLoaded (safe)
document.addEventListener('DOMContentLoaded', () => {
  window.initSwiper();
});



// WEBPACK FOOTER //
// ./src/scripts/blocks/swiper.js